export const careersContent = {
  hero: {
    eyebrow: "CAREERS AT BELAGERI",
    title: "Grow Your Career. Create an Impact.",
    description:
      "Work with passionate people, solve meaningful problems, and build technology that matters.",
    primaryButton: "Explore Open Positions",
    secondaryButton: "Why Join Us",
  },

  whyJoinUs: {
    eyebrow: "WHY BELAGERI TECH",
    title: "More Than a Job. A Place to Grow.",
    description:
      "At Belageri Technologies, we believe great products are built by people who are encouraged to learn, collaborate, take ownership, and make an impact.",
  },

  benefits: [
    {
      icon: "growth",
      title: "Career Growth",
      description:
        "Take ownership of meaningful work and build a career through continuous growth and new opportunities.",
    },
    {
      icon: "learning",
      title: "Continuous Learning",
      description:
        "Work with modern technologies while continuously developing your technical and professional skills.",
    },
    {
      icon: "team",
      title: "Collaborative Culture",
      description:
        "Work with people who value teamwork, fresh ideas, knowledge sharing, and mutual respect.",
    },
    {
      icon: "innovation",
      title: "Innovation",
      description:
        "Solve real-world business problems and contribute ideas that create meaningful and measurable impact.",
    },
    {
      icon: "impact",
      title: "Meaningful Impact",
      description:
        "Build solutions that solve real business challenges and create value for customers, businesses, and communities",
    },
    {
      icon: "ownership",
      title: "Ownership",
      description:
        "Your ideas matter. Take responsibility, make decisions, and see your work turn into real products and solutions.",
    },
  ],

  jobs: [
    {
      id: 1,
      title: "Full Stack Developer-Intern",
      department: "Engineering",
      location: "Kalaburagi, India",
      type: "Full Time",
      experience: "FRESHERS",
      posted: "Recently posted",

      description:
        "Join our engineering team as a Full Stack Developer Intern and work across both frontend and backend development. Build scalable backend services using Java, Spring Boot, Hibernate, Maven, and REST APIs, while creating modern and responsive user interfaces using JavaScript and React. Gain hands-on experience across the complete software development lifecycle.",

      skills: [
        "Java",
        "Spring Boot",
        "Hibernate",
        "Maven",
        "JavaScript",
        "React",
        "REST API",
        "PostgreSQL",
      ],
    },
  ],

  //   hiringProcess: [
  //     {
  //       number: "01",
  //       title: "Apply",
  //       description:
  //         "Submit your application and tell us about your skills, projects, and experience.",
  //     },
  //     {
  //       number: "02",
  //       title: "Screening",
  //       description:
  //         "Our team reviews your profile and gets in touch if your skills and experience match the role.",
  //     },
  //     {
  //       number: "03",
  //       title: "Technical Round",
  //       description:
  //         "Discuss your technical knowledge, problem-solving approach, projects, and practical skills.",
  //     },
  //     {
  //       number: "04",
  //       title: "Final Discussion",
  //       description:
  //         "Meet the team and discuss expectations, culture, responsibilities, and opportunities for growth.",
  //     },
  //   ],

  cta: {
    title: "Don't See the Right Role?",
    description:
      "We are always interested in meeting talented people. Send us your resume and tell us how you can contribute to Belageri Technologies.",
    button: "Send Your Resume",
  },
};
